

exports.__esModule = true;
exports.$xoReviewPageComponent = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = require('angular');

var _squid = require('squid');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('js/lib/index');

require('xo-models/src/checkout/index');

require('xo-title/dist/directive');

require('xo-ui-components/src/message/directive');

require('xo-ui-components/src/banner/directive');

require('xo-form-components/src/select-shipping-method/directive');

require('xo-member-components/src/review-address/directive');

require('xo-member-components/src/review-paywith/directive');

require('xo-page-components/src/value-props/directive');

require('xo-page-components/src/messenger-plugin/directive');

require('xo-address-components/src/address-display/directive');

require('xo-credit-components/src/offer/directive');

require('xo-return-to-merchant/dist/util');

require('xo-models/src/bml/index');

require('xo-models/src/fi/index');

require('xo-models/src/fi/lib/fiMessages');

require('xo-models/src/fi/lib/fiApis');

require('xo-models/src/auth/lib/xoAPayUtils');

require('xo-device-info/dist/index');

var _logger = require('xo-beaver/dist/logger');

require('xo-credit-components/src/bml-display/xo-bml-popup/directive');

require('xo-page-components/src/done/directive');

require('xo-page-components/src/cart/lib/pxp');

require('xo-wallet-components/src/3ds/directive');

require('xo-models/src/profilemanagement/index');

require('xo-models/src/inventory/index');

require('xo-models/src/shoppingcart/index');

require('xo-page-components/src/marketingOffers/directive');

var _integration = require('js/lib/integration');

require('xo-member-components/src/review-topup/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

var _index = require('xo-models/src/user/index');

var _fi = require('xo-models/src/fi');

var _choice = require('xo-models/src/choice');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoReviewPageComponent = exports.$xoReviewPageComponent = _squid.$Component.extend('$xoReviewPageComponent', {
    tag: 'xo-review-page',
    template: _template2['default'],
    scope: {
        redirectiframe: '=',
        redirectLightbox: '='
    },
    actions: {
        updatePreferredFi: function updatePreferredFi(logger) {
            if (this.makeFiPreferred && this.makeFiPreferred.selected) {
                var PreferredFi = new _fi.$PreferredFi({
                    preferred: [this.makeFiPreferred.fiId]
                });

                logger.info('checkout_fpti', {
                    'pref_fi_set': '1'
                });

                return PreferredFi.save({
                    transientError: true,
                    contingencies: {
                        DEFAULT: function DEFAULT() {}
                    }
                });
            }

            logger.info('checkout_fpti', {
                'pref_fi_set': '0'
            });

            return _angular.$q.when();
        }
    },
    lifecycle: {
        reenter: function reenter() {
            var msgKeys = this.checkoutSession.get('message.msgKeys', []);

            if (msgKeys.indexOf('confirmUpop.confirmUpopOrChooseAltMethod') === -1) {
                this.showUnconfirmedUpopMsg = !!this.checkoutSession.unconfirmed_upop;
            }

            // Reset the selectedmethod indicator and state change listener
            if (this.setupMultipleFi) {
                this.setupMultipleFi();
            }

            // If FS has changed due to an update, reset the preferred FI checkbox
            if (this.makeFiPreferred && this.makeFiPreferred.fiId !== this.checkoutSession.fundingOptions.plans[0].primaryFs.id) {
                _logger.$logger.info('checkout_fpti', {
                    'pref_fi_option_shown': '1'
                });
                this.makeFiPreferred.selected = false;
            }
        }
    },
    controller: function controller($scope, $state, $rootScope, $FallbackError, $populate, $DeviceInfo, $CheckoutAppDataModel, $CheckoutCartModel, $CheckoutSessionModel, $ShippingRuleSummaryModel, $feature, $AuthModel, $pxp, $config, $meta, $experiment, $miniBrowser, $locale, $pxpFactors, $window, $util, $featureCountries, $BMLModel, $ApplyForBMLModel, $CheckoutPayeeModel, $pxpCartAmt, $timeout, $unresolved, $BuyerEligibilityModel, $renderContent, $fiMessages, $fiApis, $element, $MerchantPreferenceModel, $AddCardModel, $CardModel, $CreditInstallmentModel, $InventoryModel, $CreditDataModel, $ShoppingCartModel, $WalletPreferences, $xoAPayUtils) {

        _logger.$logger.info('buyer_info', {
            fpti_buyer_type: 'Existinguser'
        });

        var showButtonPxp = false;
        // show fixed button for mobile and incontext view
        var allowFixedButton = $DeviceInfo.isMobile() || $miniBrowser.isMiniBrowser();

        $scope.token = $rootScope.token;

        $scope.backUri = 'checkout.review';

        $scope.installmentNotSelected = false;

        $scope.installment = {
            showBanner: false,
            showCYCO: false,
            showRepresentativeInfo: false
        };

        // PAD Toggle feature
        $scope.padToggleFeature = {
            applicable: false,
            checkboxEnabled: false,
            showCheckbox: false,
            defaultPlan: false,
            pxpTreatmentEnabled: false,
            pxpControlEnabled: false,
            fptiLogged: false
        };

        $scope.padToggleFeatureSupported = $feature('padToggleFeatureSupported');

        // 'continue' or 'pay now' button text
        $scope.payButtonText = function () {
            return '';
        };

        $scope.isGCcountry = ($config.giftCardSupportedCountries || '').indexOf($locale.country) > -1;

        $scope.showPaypalPolicies = $featureCountries('showPaypalPolicies').indexOf($locale.country) > -1;

        $scope.makeAddrPreferred = {
            shown: false,
            selected: false
        };

        $scope.showPolicyAgreement = $feature('showPolicyAgreement');

        $scope.isMessengerBAIntegration = _integration.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');

        $scope.personalizedBanner = {};
        function setPersonalizedBanner(buyer_id) {
            $scope.personalizedBanner.show = true;
            _index.$UserPhotoModel.instance(buyer_id).retrieve({
                params: {
                    'min_size': 45
                },
                success: function success(result) {
                    if (result && result.photo_url) {
                        $scope.personalizedBanner.imageUrl = result.photo_url;
                        _logger.$logger.info('personalized_banner_retrieve_success');
                    }
                }
            });
        }

        // Format the informal name if populated
        function setInformalName() {
            if ($scope.auth) {
                $scope.formattedNameInformal = (0, _squid.formatNameInformal)({
                    first_name: $scope.auth.first_name,
                    last_name: $scope.auth.last_name
                }) || $scope.auth.email;
            }
        }

        function updateAddressAsPreferred() {
            if ($scope.makeAddrPreferred.shown) {
                _logger.$logger.info('makeAddrPreferred.shown', {});
            }

            if ($scope.makeAddrPreferred.selected) {
                _logger.$logger.info('makeAddrPreferred.selected', {});

                // Ignore all errors from setPreferred api, by passing transientError as true
                return $scope.checkoutSession.shipping.action('setPreferred', {
                    transientError: true
                });
            }

            return _angular.$q.when();
        }

        function setStickyInstrument() {
            if (!$config.features.DEFAULT.enableStickyFunding) {
                return _angular.$q.when();
            }

            var stickyInstrument = $scope.checkoutSession.selectedFuturePaymentInstrument ? undefined : $scope.checkoutSession.getSelectedStickyInstrument();

            if (stickyInstrument) {
                return $scope.checkoutSession.action('setStickyFI', {
                    data: {
                        instrument_id: stickyInstrument.instrument_id
                    }
                });
            }

            return _angular.$q.when();
        }

        function setWalletTopupPreferences() {
            if ($scope.checkoutCart.isWalletTokenization()) {
                $scope.walletPreferences = $WalletPreferences.instance($scope.token);
                return $scope.walletPreferences.save();
            }
        }

        function show3DSLightbox() {
            $scope.resolve_3ds_data = {
                cc_id: $scope.checkoutSession.get('resolve_3ds.ccId'),
                flow_id: 'HERMES',
                merchant_id: $scope.payee.get('merchant.id'),
                merchant_country_code: $scope.checkoutAppData.get('merchant.merchant_country'),
                transaction_amount_currency: $scope.checkoutCart.get('purchase.amounts.total.currency_code'),
                transaction_amount_value: $scope.checkoutCart.get('purchase.amounts.total.amount')
            };
            $scope.launch3DSResolver = true;
        }

        function showGenericError(code) {
            return function () {
                inventoryOperation('failed');
                var encoded = code ? window.btoa(code) : code;
                return $state.go('checkout.genericError', {
                    code: encoded
                });
            };
        }

        function getMerchantPreferences() {

            return $populate($scope, {
                pref: $MerchantPreferenceModel.instance($scope.payee.merchant.id)
            });
        }

        function setProcessorDeclineMessage() {

            var processorDeclinedMsg = $fiMessages.processorDeclinedMsg($scope.checkoutSession, true);

            if (processorDeclinedMsg) {
                $scope.checkoutSession.message = {
                    type: processorDeclinedMsg.type,
                    msgs: [processorDeclinedMsg.msg]
                };
            }
        }

        function makePayment() {
            var wpsParams = $util.decodeAndParse($meta.xclickParams);

            return $scope.checkoutSession.action('createPayment', {
                data: {
                    payer_id: $scope.checkoutSession.payer.id,
                    intent: $scope.checkoutCart.payment_action,
                    wa_type: wpsParams && wpsParams.wa_type,
                    correlation_id: $meta.correlationId,
                    merchant_id: $scope.payee.get('merchant.id'),
                    custom: $scope.checkoutCart.get('purchase.custom'),
                    invoice: $scope.checkoutCart.get('purchase.invoice')
                },

                success: function success(result) {
                    $rootScope.paymentComplete = true;
                    _logger.$logger.info('wps_cart_to_txn_mapping', {
                        cart_id: $scope.token,
                        txn_id: result.transactionDetails && result.transactionDetails.id,
                        txn_receipt_id: result.transactionDetails && result.transactionDetails.receipt_id
                    });
                    return 'success';
                },

                contingencies: {
                    TRANSACTION_REFUSED: showGenericError('TRANSACTION_REFUSED'),
                    PAYEE_BLOCKED_TRANSACTION: showGenericError('PAYMENT_DENIED'),
                    DUPLICATE_TRANSACTION: showGenericError('PAYMENT_ALREADY_DONE'),
                    CC_PROCESSOR_DECLINED: function CC_PROCESSOR_DECLINED() {
                        inventoryOperation('failed');
                        return $scope.checkoutSession.action('create', {
                            success: function success(result) {
                                setProcessorDeclineMessage();
                                return $state.go('checkout.review');
                            },
                            contingencies: {
                                DEFAULT: function DEFAULT(name, err) {
                                    throw err;
                                }
                            }

                        });
                    },
                    DEFAULT: function DEFAULT(name, err) {
                        inventoryOperation('failed');
                        throw err;
                    }

                }
            });
        }

        function inventoryOperation(paymentStatus) {
            var cartHasInventory = $scope.checkoutCart.get('cartHasInventory');
            if (cartHasInventory) {
                var inventoryModel = $InventoryModel.instance($rootScope.token);
                var inventoryItems = inventoryModel.getInventoryItems();
                paymentStatus = paymentStatus ? paymentStatus : 'success';
                var inventoryPatchInput = {
                    inventoryItems: inventoryItems,
                    cartItems: $scope.checkoutCart.get('purchaseUnits')[0].item_list.items,
                    merchantId: $scope.payee.get('merchant.id', ''),
                    paymentStatus: paymentStatus
                };
                return inventoryModel.action('patchInventory', {
                    data: inventoryPatchInput,
                    success: function success(patchResponse) {
                        if (patchResponse.showSoldoutPage) {
                            // show soldout page
                            return {
                                soldoutpage: true,
                                items: patchResponse.soldoutItems,
                                soldOutUrl: patchResponse.soldoutUrl
                            };
                        } else if (patchResponse.patchCart) {
                            var purchase_unit = $scope.checkoutCart.get('purchaseUnits')[0];
                            purchase_unit.item_list.items = patchResponse.cartItems;
                            var patchCartPayload = {
                                id: $scope.token,
                                patchEntities: [{
                                    field: 'inventoryItems',
                                    value: purchase_unit.item_list.items
                                }]
                            };

                            return $scope.checkoutCart.action('patchCartData', {
                                data: patchCartPayload
                            });
                        }
                        return;
                    }
                });
            } else {
                return _angular.$q.when(); // not an inventory request proceed with existing flow
            }
        }

        function markCartCheckedout() {
            var shoppingCartModel = $ShoppingCartModel.instance($rootScope.token);
            return shoppingCartModel.action('cartCheckedOut', {
                data: {
                    payee_email: $scope.checkoutAppData.get('merchant.merchant_email')
                },
                success: function success(result) {
                    _logger.$logger.info('cart checked out successfully');
                }
            });
        }

        function isPadToggleFeatureApplicable() {
            var padToggle = false;
            if ($scope.padToggleFeatureSupported && $scope.padToggleFeature.pxpTreatmentEnabled && $scope.padToggleFeature.applicable) {
                padToggle = true;
            }

            return padToggle;
        }

        function getPadToggleStatus() {
            var toggleStatus = 'NA'; // NOT APPLICABLE status
            if (isPadToggleFeatureApplicable()) {
                if ($scope.checkoutSession.plan.isPAD() && $scope.padToggleFeature.checkboxEnabled) {
                    toggleStatus = 'ON';
                } else {
                    toggleStatus = 'OFF';
                }
            }

            return toggleStatus;
        }

        function authorize() {
            if ($scope.checkoutSession.resolve_3ds) {
                return show3DSLightbox();
            }

            function isXoonUpopRedirect() {
                if (!($scope.checkoutSession && $scope.checkoutSession.get('errorData.resolution.data.fi.type'))) {
                    return false;
                }

                return $util.param('redirectToHermesOnUpopCancel') === 'xoon' && $scope.checkoutSession.errorData.resolution.name === 'PAYER_TO_AUTHENTICATE_CARD' && !$scope.checkoutSession.errorData.resolution.data.alternate_options && $scope.checkoutSession.errorData.resolution.data.fi.type.toUpperCase() === 'CUP';
            }

            if ($scope.checkoutSession.unconfirmed_upop || isXoonUpopRedirect()) {
                var card = void 0;
                if ($scope.checkoutSession.unconfirmed_upop) {
                    card = $scope.checkoutSession.unconfirmed_upop;
                } else {
                    card = $scope.checkoutSession.errorData.resolution.data;
                }

                $scope.cardModel = new $AddCardModel({});
                $scope.cardModel.id = card.fundingId;
                $scope.cardModel.card = new $CardModel({
                    number: 'xxxx-xxxx-xxxx-' + card.fi.number,
                    type: card.fi.type.toUpperCase(),
                    productType: card.fi.productType
                });

                $state.go('.confirmUpop');
                return;
            }

            if ($scope.checkoutCart.isWalletTokenization()) {
                $xoAPayUtils.setAPayCookie($scope.token);
            }

            return $scope.checkoutSession.action('authorize', {
                success: function success() {
                    if ($scope.checkoutSession.get('plan.paypal_credit')) {
                        _logger.$logger.info('checkout_fpti', {
                            'ppc_reuse_status': 'success'
                        });
                    }

                    var padToggleStatus = getPadToggleStatus();

                    if (padToggleStatus === 'ON') {
                        _logger.$logger.info('checkout_fpti', {
                            'pad_toggle_status': 'padToggleOnSuccess'
                        });
                    } else if (padToggleStatus === 'OFF') {
                        _logger.$logger.info('checkout_fpti', {
                            'pad_toggle_status': 'padToggleOffSuccess'
                        });
                    }

                    if ($scope.checkoutCart.isWalletTokenization()) {
                        _logger.$logger.info('tokenized_wallet', {
                            'from': 'TopUp_REVIEW',
                            'to': 'process_review',
                            'topup_amt': $scope.walletPreferences.topup.amount,
                            'currency_code': $scope.walletPreferences.topup.currency,
                            'context_id': $scope.token,
                            'context_type': 'BA-Token',
                            'billing_token': $meta.baToken
                        });
                    }

                    if (window.xchild) {
                        return $state.go('checkout.end');
                    }

                    if (_integration.$integration.getConfig('DONE_PAGE')) {
                        return inventoryOperation().then(function (result) {
                            if (result && result.soldoutpage) {
                                return $state.go('checkout.soldout', {
                                    items: encodeURIComponent(result.items),
                                    soldOutUrl: encodeURIComponent(result.soldOutUrl)
                                });
                            }
                            return _angular.$q.all([makePayment(), getMerchantPreferences()]).then(function () {
                                if ($rootScope.paymentComplete) {
                                    if ($config.enableShoppingCartWPS && $scope.checkoutAppData.flags.is_shopping_cart_flow) {
                                        markCartCheckedout();
                                    }

                                    return $state.go('checkout.done');
                                }
                            });
                        });
                    } else {
                        if ($scope.checkoutSession.get('sepa_mandate.bankId')) {
                            return $state.go('checkout.sepapage');
                        }

                        return $state.go('checkout.end');
                    }
                }
            });
        }

        function setShowShippingMethodProperty() {
            return $populate($scope, {
                shippingRulesSummary: $ShippingRuleSummaryModel.instance($rootScope.token).retrieve({
                    params: {
                        merchant_id: $scope.payee.get('merchant.id'),
                        currency_code: $scope.checkoutCart.get('purchase.amounts.total.currency_code')
                    }
                })
            }).then(function () {
                if ($scope.shippingRulesSummary.isSnTEnabled) {
                    _logger.$logger.info('shipping_rules_summary_snt_enabled');
                } else {
                    _logger.$logger.info('shipping_rules_summary_snt_disabled');
                }
                $scope.showShippingMethod = $scope.shippingRulesSummary.isSnTEnabled;
                return;
            });
        }

        function show3DSDeclineMsg(declineAfter3DSAccept) {
            var key = 'threeDS.memberDecline';

            if (declineAfter3DSAccept) {
                key = 'threeDS.memberDeclineAfter3DSAccept';
            }

            var card = $scope.checkoutSession.resolve_3ds;

            if (card) {
                var msg = $renderContent(key, {
                    cardType: card.type,
                    last4: card.number
                });

                $scope.checkoutSession.message = {
                    msgs: [msg],
                    type: 'warning'
                };
            }
        }

        /**
         * call patchXO API to clear the 3DS contingency and then call authorize API.
         */
        function clear3DSContingency() {
            var resolve_3ds = $scope.checkoutSession.resolve_3ds || {};

            return $scope.checkoutSession.action('clear3DSContingency', {
                data: {
                    ccId: resolve_3ds.ccId
                },
                success: function success(response) {
                    if (!$scope.checkoutSession.resolve_3ds) {
                        return authorize();
                    } else {
                        // Symphony is not able to clear the 3DS contingency
                        show3DSDeclineMsg(true);
                    }
                }
            });
        }

        $scope.onComplete3DSHandler = function (status) {
            $scope.launch3DSResolver = false;
            if (status === 'success') {
                return clear3DSContingency();
            } else if (status === 'decline') {
                // 3DS got declined
                show3DSDeclineMsg();
            }
        };

        $scope.onConfirmUpopSuccess = function () {
            $state.go('checkout.review');
            $scope.checkoutSession.action('clearContingency', {
                data: {
                    contingency: 'UNCONFIRMED_UPOP',
                    ccId: $scope.checkoutSession.get('unconfirmed_upop.fundingId') || $scope.checkoutSession.get('errorData.resolution.data.fundingId')
                },
                success: function success() {
                    if (!$scope.checkoutSession.unconfirmed_upop) {
                        return authorize();
                    } else {
                        $scope.checkoutSession.message = {
                            type: 'warning',
                            msgKeys: ['confirmUpop.confirmUpopOrChooseAltMethod']
                        };
                    }
                }
            });
        };

        $scope.onConfirmUpopCancel = function () {
            $state.go('checkout.review');
            $scope.showUnconfirmedUpopMsg = false;
            $scope.checkoutSession.message = {
                type: 'warning',
                msgKeys: ['confirmUpop.confirmUpopOrChooseAltMethod']
            };
        };

        $scope.returnFromCape = function (isCapeReturnKey) {
            return $scope.creditDataModel.action('readCreditKey', {
                data: {
                    capeKey: isCapeReturnKey
                },
                success: function success(res) {

                    if (res.financial_instrument_id) {
                        var financial_instrument_id = res.financial_instrument_id.indexOf('BC') !== 0 ? 'BC' + res.financial_instrument_id : res.financial_instrument_id;

                        return $scope.checkoutSession.fundingOptions.action('update', {
                            resultModel: $scope.checkoutSession,
                            data: {
                                planId: financial_instrument_id
                            },
                            success: function success(result) {
                                $scope.checkoutSession.message = {
                                    type: 'success',
                                    msgKeys: ['offers.bmlInWalletSuccessMsg']
                                };

                                if ($scope.setupMultipleFi) {
                                    $scope.setupMultipleFi();
                                }
                            }
                        });
                    }

                    // User does not have any FI in wallet and they choose to pay in full.
                    else if (!$scope.checkoutSession.get('plan.sources') && $scope.checkoutSession.isCreditPromoted) {
                            $state.go('checkout.pageAddCard.addCardFlow.addCard');
                        } else if ($scope.creditDataModel.isCapeInternalServiceError()) {
                            // Todo Show error message from CAPE
                            return _angular.$q.when();
                        } else {
                            return _angular.$q.when();
                        }
                },
                contingencies: {
                    DEFAULT: function DEFAULT(name, err) {
                        _logger.$logger.info('read_cape_key_failure');
                        return _angular.$q.when();
                    }
                }

            });
        };

        // For the multiple FI variant of the choice experiment:
        // Update the funding option in the plan based on the user's stored selection
        function updateFS() {

            if ($scope.selectedmethod && $scope.checkoutSession.get('plan.sources')[0].id !== $scope.selectedmethod.planId) {

                return $scope.checkoutSession.fundingOptions.action('select', {
                    data: {
                        planId: $scope.selectedmethod.planId
                    },
                    success: function success(result) {
                        $scope.checkoutSession.populate(result);
                    }
                    // TODO: contingency handler
                });
            } else {
                return _angular.$q.when();
            }
        }

        $populate($scope, {
            auth: $AuthModel.instance(),
            checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
            checkoutCart: $CheckoutCartModel.instance($scope.token),
            checkoutSession: $CheckoutSessionModel.instance($scope.token),
            payee: $CheckoutPayeeModel.instance($scope.token),
            buyerEligibility: $BuyerEligibilityModel.instance($scope.token)
        }).then(function () {
            // Get the choice experiment variant to determine what needs to be shown in the UI
            return _choice.$ChoiceEligibility.instance().getVariant($scope.token).then(function (variant) {
                $scope.choiceVariant = variant;

                var checkboxVariants = $config.choiceExperiment && $config.choiceExperiment.preferredCheckbox || [];
                var multipleFiVariants = $config.choiceExperiment && $config.choiceExperiment.multipleFi || [];
                var selectFiVariants = $config.choiceExperiment && $config.choiceExperiment.selectFi || [];

                if (checkboxVariants.indexOf(variant) !== -1) {
                    // Do setup for preferred checkbox
                    $scope.makeFiPreferred = {
                        selected: false
                    };
                }

                if (multipleFiVariants.indexOf(variant) !== -1) {
                    // Do the setup for the multipleFiVariant
                    $scope.setupMultipleFi = function () {
                        $scope.selectedmethod = {
                            index: 0,
                            planId: $scope.checkoutSession.get('plan.sources')[0].id
                        };

                        if ($scope.cancelUpdateListener) {
                            $scope.cancelUpdateListener();
                        }

                        // Before changing state, persist the change that the user selected
                        $scope.cancelUpdateListener = $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
                            $scope.cancelUpdateListener();
                            if ($scope.checkoutSession.get('plan.sources')[0].id === $scope.selectedmethod.planId) {
                                return;
                            }

                            event.preventDefault();
                            updateFS().then(function () {
                                return $state.go(toState, toParams);
                            });
                        });

                        $scope.$on('$destroy', $scope.cancelUpdateListener);
                    };

                    $scope.setupMultipleFi();
                }

                if (selectFiVariants.indexOf(variant) !== -1) {
                    $scope.selectFiVariant = true;
                }
            })['catch'](function (err) {
                // TODO: Check what happens to PXP errors
                _logger.$logger.error('choice_eligibility_error', err);
            });
        }).then(function () {
            if ($util.param('redirectToHermesOnUpopCancel') === 'xoon') {
                var fiModel = $scope.checkoutSession.get('plan.sources');
                if (fiModel && fiModel.length && fiModel[0].card_type === 'CHINA_UNION_PAY') {
                    $scope.checkoutSession.message = {
                        msgKeys: ['confirmUpop.confirmUpopToPay'],
                        type: 'warning'
                    };
                }
            }

            if ($scope.checkoutCart.isWalletTokenization()) {
                _logger.$logger.info('tokenized_wallet', {
                    'from': 'TopUp_REVIEW',
                    'to': 'prepare_review',
                    'context_id': $scope.token,
                    'context_type': 'EC-Token',
                    'billing_token': $meta.baToken
                });
            }
            var merchantCountry = $scope.checkoutAppData.merchant.merchant_country;
            var personalizationEnabled = $feature('oneTouchPersonalization');
            $scope.showRemittanceDisclosure = $DeviceInfo.isMobile() && $scope.checkoutSession.showRemittanceDisclosure ? true : false;
            if ($scope.auth.remembered && personalizationEnabled) {
                $pxp('xo_hermesnode_config', { 'ctx.COUNTRY': merchantCountry }, 'xo_hermesnode_kmli_personalization_treatment').then(function (result) {
                    var treatmentName = result && result.treatment_name || '';
                    if (treatmentName) {
                        _logger.$logger.info('personalized_banner_enabled');
                        setPersonalizedBanner($scope.auth.buyer_id);
                        delete $scope.checkoutSession.message;
                    } else {
                        $scope.personalizedBanner.show = false;
                        delete $scope.auth.rtExchanged;
                        _logger.$logger.info('personalized_banner_disabled');
                    }
                });
            } else {
                _logger.$logger.info('personalized_banner_ineligible', {
                    'isFeature': personalizationEnabled,
                    'isOneTouch': $scope.auth.remembered
                });
                if ($scope.auth.rtExchanged) {
                    delete $scope.auth.rtExchanged;
                }
            }

            if ($scope.padToggleFeatureSupported) {
                return $pxp('xo_de_hermes_pad_toggle', {
                    'ctx.COUNTRY': $locale.country
                }, '(xo_de_hermes_pad_toggle_)(.*)').then(function (result) {
                    var treatmentName = result && result.treatment_name || '';
                    if (treatmentName === 'xo_de_hermes_pad_toggle_treatment') {
                        _logger.$logger.info('pad_toggle_treatment_applicable');
                        $scope.padToggleFeature.pxpTreatmentEnabled = true;
                    } else if (treatmentName === 'xo_de_hermes_pad_toggle_control') {
                        _logger.$logger.info('pad_toggle_control_applicable');
                        $scope.padToggleFeature.pxpControlEnabled = true;
                    } else {
                        _logger.$logger.info('pad_toggle_treatment_and_control_not_applicable');
                    }
                });
            }
        }).then(function () {
            $scope.logout = function () {
                _logger.$logger.info('not_you_logout');

                if (window.xchild && $util.isIFrame()) {

                    window.xchild.hide();

                    var url = window.location.href.split('#')[0];

                    var xprops = _extends({}, window.xprops);

                    xprops.url = url;
                    xprops.payment = function () {
                        return $scope.auth.action('logout').then(function () {
                            return $scope.token;
                        });
                    };

                    return window.ppxo.Checkout.renderPopupTo(window.top, xprops);
                }

                $scope.auth.action('logout').then(function () {
                    $state.go('checkout.login', {
                        source: 'NOT_YOU'
                    });
                });
            };

            $scope.creditDataModel = $CreditDataModel.instance($scope.token);
            var isChangeInstallments = $scope.creditDataModel.isChangeStatus();
            var isCapeReturnKey = $scope.creditDataModel.getCapeKey();
            var isCapeReturn = isCapeReturnKey && $util.param('success');

            if (isChangeInstallments && $scope.creditDataModel && !$scope.creditDataModel.payInFull) {
                $state.go('checkout.chooseCreditOffer');
            }
            if (isCapeReturn) {
                $scope.returnFromCape(isCapeReturnKey);
            }

            if ($feature('creditInstallmentOffers') && ($scope.checkoutSession.get('plan.paypal_credit') || isCapeReturnKey)) {
                $scope.creditOptions = $CreditInstallmentModel.instance($scope.token);
                $scope.creditOptions.retrieve();
            }

            $scope.cartCurrency = $scope.checkoutCart.get('purchase.amounts.total.currency_code');

            $scope.showInstallmentOption = function () {
                if ($feature('creditInstallmentOffers') && $scope.checkoutSession.get('plan.paypal_credit') && $scope.creditOptions && $scope.creditOptions.creditType) {
                    if ($scope.creditOptions.creditType === 'INST') {
                        $scope.installmentInfo = {
                            monthlyPaymentAmt: (0, _squid.formatCurrency)($scope.creditOptions.monthlyPayment, $scope.cartCurrency),
                            totalInterestAmt: (0, _squid.formatCurrency)($scope.creditOptions.totalInterest, $scope.cartCurrency),
                            totalPaymentAmt: (0, _squid.formatCurrency)($scope.creditOptions.totalPayment, $scope.cartCurrency)
                        };
                    }
                    return true;
                } else {
                    return false;
                }
            };

            $scope.showCYCO = function () {
                $state.go('checkout.chooseCreditOffer');
            };

            $scope.showRepresentativeInfo = function () {
                return $locale.country === 'GB' && $scope.installment.showRepresentativeInfo;
            };

            if (!$scope.buyerEligibility.eligible) {
                throw new $FallbackError({
                    reason: 'buyer_ineligible',
                    product: 'ux'
                });
            }

            if ($window.location.search.search('atoSuccess') !== -1) {
                _logger.$logger.debug('PLANNING_ATO_SUCCESS');
                var atoMsg = $locale.content.get('memberReview.stepupAuthSuccess');

                if (atoMsg) {
                    $scope.checkoutSession.message = {
                        msgs: [atoMsg],
                        type: 'success'
                    };
                }
            }

            $scope.$on('localeChange', setInformalName);
            setInformalName();

            $scope.showNotYou = $scope.auth.is_auth_api_call && $util.param('source') !== 'consumerApp' && !$util.param('redirectToHermesOn3DSDecline');

            if ($util.param('redirectToHermesOn3DSDecline')) {
                // check and show the 3DS decline message when the app is redirected from Xoon app
                show3DSDeclineMsg();
            }

            $scope.showAuthMsg = ['authorize', 'order'].indexOf($scope.checkoutCart.get('payment_action')) > -1 && !$scope.checkoutSession.get('plan.paypal_credit');

            $scope.showUnconfirmedUpopMsg = !!$scope.checkoutSession.unconfirmed_upop;

            $scope.useraction = $scope.checkoutAppData.useraction() && $scope.checkoutAppData.useraction().toLowerCase();

            // Non-AU merchants are subjected to PXP test when user action is not commit and line item details
            // are not available and purchase amount is not zero.
            var noLineItemDetails = $scope.useraction !== 'commit' && $scope.checkoutCart.get('purchase.items.length', 0) === 0;

            if ($scope.checkoutSession.bmlOffer) {
                if (!$rootScope.bml) {
                    $rootScope.bml = new $BMLModel();
                }
                $rootScope.bmlApply = new $ApplyForBMLModel();
            }

            $scope.showSoftDescriptor = !$scope.checkoutAppData.flags.hide_soft_descriptor && $scope.checkoutCart.get('purchaseUnits.length', 0) <= 1;

            return $pxpCartAmt($scope.checkoutAppData.get('merchant.merchant_country'), $scope.payee.get('merchant.id', ''), noLineItemDetails, $scope.checkoutCart.isPurchase()).then(function (showAmount) {
                $scope.showAmt = showAmount;
            });
        }).then(function () {
            var checkoutSession = $scope.checkoutSession,
                negBals = checkoutSession.negBals,
                nbrMsgContentKey,
                tokenHash;

            if (negBals) {

                nbrMsgContentKey = 'memberReview.nbrMsg';
                tokenHash = {
                    neg_bal: (0, _squid.formatCurrency)(negBals[0].amount, negBals[0].currency_code, false),
                    merchantName: $scope.checkoutAppData.get('merchant.brand_name')
                };

                if (negBals.length > 1) {
                    nbrMsgContentKey += 'Plural';
                    tokenHash.neg_bal2 = (0, _squid.formatCurrency)(negBals[1].amount, negBals[1].currency_code, false);
                }

                checkoutSession.message = {
                    type: 'warning',
                    msgs: [$renderContent(nbrMsgContentKey, tokenHash)]
                };
            }
        }).then(function () {
            if (allowFixedButton) {
                return $pxp('xo_hermes_fixed_button', {}, 'xo_hermes_fixed_button_test_group').then(function (result) {
                    showButtonPxp = result && result.treatment_name === 'xo_hermes_fixed_button_test_group';
                });
            }
        }).then(function () {
            if (!$miniBrowser.isMiniBrowser() && $locale.country === 'BR') {
                var brPxp = $config.pxpExperiments.BR.xo_br_hermesnode_ryi_design;

                $pxpFactors(brPxp.pgName, brPxp.params, brPxp.pattern).then(function (result) {
                    $scope.ryiDesignExp = result;
                });
            }
        }).then(function () {
            $scope.showShippingMethod = false;
            if (_integration.$integration.getConfig('SHOW_SHIPPING_METHOD')) {
                return setShowShippingMethodProperty();
            }
            return _angular.$q.when();
        }).then(function () {
            $scope.cancel = $scope.checkoutAppData.urls.cancel_url;

            var isBilling = $scope.checkoutCart.isBilling();
            var isBillingPurchase = $scope.checkoutCart.isBillingPurchase();
            $scope.merchantMsg = $scope.checkoutCart.getBillingDescription();

            /* -- refined by creating isBilling and isBillingPurchase variables -- */
            $scope.showReviewLater = !$scope.showAmt && (!isBilling || isBillingPurchase);

            // show shipping address based on merchant passed in parameter
            $scope.showShippingAddress = Boolean(!$scope.checkoutAppData.flags.hide_shipping_address && $scope.checkoutAppData.flags.shipping_address_required && $scope.checkoutSession.shipping);

            /* -- end refined -- */

            // review page 'continue' or 'pay now' button logic to return the button text
            $scope.payButtonText = function () {

                if (isBilling) {
                    if ($scope.useraction === 'commit') {
                        return $locale.content.get('memberReview.agreeAndPayLabel');
                    } else {
                        return $locale.content.get('memberReview.agreeAndContinueLabel');
                    }
                } else if (getPadToggleStatus() === 'ON') {
                    return $locale.content.get('memberReview.padLabel');
                } else if (_integration.$integration.getConfig('SHOW_PAY_NOW_LABEL_ON_REVIEW') || $scope.useraction === 'commit') {
                    if ($scope.checkoutSession.unconfirmed_upop) {
                        return $locale.content.get('memberReview.pay');
                    } else {
                        $scope.payButton = 'paynnow_y';
                        return $locale.content.get('memberReview.payLabel');
                    }
                } else {
                    $scope.payButton = 'paynnow_n';
                    return $locale.content.get('memberReview.continueLabel');
                }
            };

            $scope.onRedeemGC = function () {
                throw new $FallbackError({
                    reason: 'redeem_coupon_feature_not_supported',
                    product: 'ux'
                });
            };

            // Check if processor decline message needs to be set
            setProcessorDeclineMessage();

            var isButtonBelowScreen = function isButtonBelowScreen() {
                var $button = $element.find('#button')[0];
                var $windowElement = (0, _jquery2['default'])(window)[0];

                if (!$button) {
                    return;
                }

                var windowTop = $windowElement.scrollY;
                var windowBottom = windowTop + $windowElement.screen.height;

                var buttonTop = windowTop + $button.getBoundingClientRect().top;
                var buttonBottom = buttonTop + $button.offsetHeight;

                return !(buttonBottom <= windowBottom && buttonTop >= windowTop);
            };

            $scope.showFixedButton = function () {
                return allowFixedButton && showButtonPxp && isButtonBelowScreen();
            };

            $timeout(function () {
                if (!allowFixedButton) {
                    return false;
                }

                if ($scope.showFixedButton()) {
                    _logger.$logger.info('button_below_screen', {
                        fpti_fixed_button_pxp: 'test'
                    });
                } else if (isButtonBelowScreen() && !showButtonPxp) {
                    _logger.$logger.info('button_below_screen', {
                        fpti_fixed_button_pxp: 'control'
                    });
                }
            }, 500);

            if (allowFixedButton && showButtonPxp) {
                (0, _jquery2['default'])(window).bind('scroll', function () {
                    $scope.$apply();
                });
            }

            $scope.$on('$destroy', function () {
                (0, _jquery2['default'])(window).unbind('scroll');
            });

            $scope.promotion = {
                type: null,
                name: ''
            };

            var plccOffer = $scope.checkoutSession.plccOffer;

            if (plccOffer) {
                $scope.promotion.logoUrl = plccOffer.product_logo;
                $scope.promotion.name = plccOffer.product_name;
            }

            $scope.onFBBANotNow = function () {
                window.xchild.close();
            };

            $scope.onPay = function (result) {
                if ($scope.checkoutSession.installments && $scope.checkoutSession.installments.length > 1 && !$scope.checkoutSession.selectedInstallmentData) {
                    $scope.installmentNotSelected = true;
                    return;
                }

                _logger.$logger.info('checkout_fpti', {
                    'ryp_button_text': $scope.payButton
                });

                if ($feature('creditInstallmentOffers') && $scope.checkoutSession.get('plan.paypal_credit') && $scope.installment.showCYCO && $scope.creditOptions && !$scope.creditOptions.creditType) {
                    return $state.go('checkout.chooseCreditOffer');
                }
                // Address Normalization Checks
                if ($scope.checkoutAppData.get('flags.allow_change_shipping', false) && $feature('shippingAddressNormalization') && $scope.checkoutSession.get('shipping.normalization_status') === 'UNKNOWN') {

                    return $state.go('checkout.review.sidebar.updateShipping');
                }

                var padToggleStatus = getPadToggleStatus();

                if (padToggleStatus === 'ON') {
                    _logger.$logger.info('checkout_fpti', {
                        'pad_toggle_status': 'padToggleOnSubmit'
                    });
                } else if (padToggleStatus === 'OFF') {
                    _logger.$logger.info('checkout_fpti', {
                        'pad_toggle_status': 'padToggleOffSubmit'
                    });
                }

                /* Call patchCvv first, if error, need buyers to input again */
                /* Call to set Sticky Funding Instrument for Billing Agreement.
                 *  We have to ensure the sticky call happens before authorize due to symphony spec.*/
                /* We need to wait for the response from updateAddressAsPreferred before calling authorize */

                return updateFS().then(function () {
                    return $fiApis.patchCvv($scope.checkoutSession);
                }).then(function () {
                    return _angular.$q.all([setWalletTopupPreferences(), setStickyInstrument(), updateAddressAsPreferred(), $scope.actions.updatePreferredFi(_logger.$logger)])['catch'](function (err) {
                        // should we have more elaborate error handling here?
                        _logger.$logger.error('onPay() error', err);
                    })['finally'](function () {
                        return authorize();
                    });
                }, function (err) {
                    _logger.$logger.error('onPay() patchCvv error', err);
                });
            };

            /* This is used for a BML 'popup' that opens covering the whole review page,
             hiding the rest of the review page when its open. */
            $scope.bmlPopupOpen = false;

            $scope.showBmlPopup = function () {
                $scope.bmlPopupOpen = true;
            };

            $scope.hideBmlPopup = function () {
                $scope.bmlPopupOpen = false;
            };
        });
        (0, _jquery2['default'])('.paypalHeaderWrapper').removeClass('paypalCredit');
        (0, _jquery2['default'])('.paypalHeaderWrapper').removeClass('paypalCreditTnc');

        $scope.onComplete = function () {
            $state.go('checkout.review');
        };
        $scope.propValueObj = {};
        if ($feature('propValue')) {
            $scope.propValueObj.propHeader = 'memberReview.propHead';
            $scope.propValueObj.propVal = 'memberReview.propVal';
            $scope.propValueObj.propImage = 'https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_shield_bags.png';
        } else {
            $scope.propValueObj.propHeader = 'login.propHeadAlt';
            $scope.propValueObj.propVal = 'login.propValAlt';
            $scope.propValueObj.propImage = 'https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_wallet_card_v3.png';
        }
    }
});

angular.value("$xoReviewPageComponent", $xoReviewPageComponent);
_angular.$q;

_squid.formatCurrency;

_squid.$Component;

_squid.formatNameInformal;

_integration.$integration;

_index.$UserPhotoModel;

_fi.$PreferredFi;

_choice.$ChoiceEligibility;

_logger.$logger;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-review/directive.js
// module id = ./pages/xo-review/directive.js
// module chunks = 1